module.exports = __webpack_public_path__ + "static/media/open-lock.a20f9cdd.png";